import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';
import axios from 'axios';

import * as Endpoints from 'constants/endpoints.constant';
import { UPDATE_CUSTOMER } from 'constants/endpoints.constant';

class CustomerOnboardingHttp {
  static getCustomerList = async () =>
    Http.setMethod(httpMethods.get)
      .setUrl(Endpoints.GET_ALL_CUSTOMERS)
      .setToken(api.getToken())
      .request();

  static getUserProfile = async (userId: any) =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.GET_USER_PROFILE}`)
      .setToken(api.getToken())
      .request();

  static sendAadhaarOtp = async (data: any, userId: any) => {
    const newData = { ...data, user_id: userId };
    return  Http.setMethod(httpMethods.post)
      .setData(newData)
      .setUrl(Endpoints.AADHAAR_SEND_OTP)
      .setToken(api.getToken())
      .request();
  };

  static verifyAadhaarOtp = async (data: any, userId: any) => {
    const newData = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.post)
      .setData(newData)
      .setUrl(Endpoints.AADHAAR_VERIFY_OTP)
      .setToken(api.getToken())
      .request();
  };

  static createCustomer = async (data: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.post)
      .setData(newdata)
      .setUrl(Endpoints.CREATE_CUSTOMER)
      .setToken(api.getToken())
      .request();
  };

  static updateCustomer = async (data: any, customerId: any, userId: any) => {
    const newdata = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.patch)
      .setData(newdata)
      .setUrl(`${Endpoints.UPDATE_CUSTOMER}/${customerId}`)
      .setToken(api.getToken())
      .request();
  };

  static createAccount = async (data: any, userId: any) => {
    const newData = { ...data, user_id: userId };
    return Http.setMethod(httpMethods.post)
      .setData(newData)
      .setUrl(Endpoints.CREATE_ACCOUNT)
      .setToken(api.getToken())
      .request();
  };

  /**
   * Create GSTIN Account
   * @param data GSTIN Payload
   * @returns
   */
  static createGstAccount = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.ADD_GST_ACCOUNT)
      .setToken(api.getToken())
      .request();

  /**
   * Create Non GSTIN Account
   * @param data GSTIN Payload
   * @returns
   */
  static createNonGstAccount = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.ADD_NONGST_ACCOUNT)
      .setToken(api.getToken())
      .request();

  static panOcr = async (data: any) => {
    return await axios({
      method: 'post',
      url: process.env.REACT_APP_URL + Endpoints.PAN_OCR,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + api.getToken(),
      },
    });
  };

  static verifyPanNumber = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.PAN_NUMBER_VERIFY)
      .setToken(api.getToken())
      .request();

  static checkPanLimit = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.CHECK_PAN_LIMIT)
      .setToken(api.getToken())
      .request();

  static getStatebyPincode = async (data: string) =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.STATE_PIN_MAPPING}?pincode=${data}`)
      .setToken(api.getToken())
      .request();

  static getGstns = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.GSTN_LIST)
      .setToken(api.getToken())
      .request();

  static getGstnDetails = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(Endpoints.GSTN)
      .setToken(api.getToken())
      .request();
}

export default CustomerOnboardingHttp;
